import Skeleton from 'react-loading-skeleton';
import styled from 'styled-components';

export const Wrapper = styled.div`
  height: 92px;
  background-color: ${(props) => props.theme.colors.headerColor};
  padding: 16px 0;
  display: flex;
  justify-content: center;
  box-shadow: 0px 0px 10px rgba(36, 36, 36, 0.2);

  @media screen and (max-width: 960px) {
    justify-content: initial;
    height: 60px;
  }
`;

export const Container = styled.div`
  width: 1200px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 9px 0;

  @media screen and (max-width: 1200px) {
    width: 100%;
    padding: 10px 20px 10px 12px;
  }
`;

export const Title = styled.h2`
  text-transform: uppercase;
  display: flex;
  flex-direction: column;

  #t1 {
    color: #262626;
    font-weight: bold;
    font-size: 36px;
  }

  #t2 {
    color: ${(props) => props.theme.colors.primary};
    font-weight: 300;
    font-size: 21px;
  }

  @media screen and (max-width: 960px) {
    #t1 {
      font-size: 20px;
    }

    #t2 {
      font-size: 12px;
    }
  }
`;

export const LogoDiv = styled.div<{ page?: string }>`
  display: flex;
  align-items: center;
  cursor: ${({ page }) => (page === 'contrato' ? 'default' : 'pointer')};

  img + img {
    margin-left: 8px;
  }
`;

interface ImgProps {
  mobile?: boolean;
}

export const Img = styled.img<ImgProps>`
  width: 221px;
  height: 74px;
  @media screen and (max-width: 960px) {
    width: 120px;
    height: 40px;
    display: inline;
  }
`;

export const SkeletonLoad = styled(Skeleton)`
  height: 50px;

  @media screen and (max-width: 960px) {
    height: 30px;
  }
`;
